import React from 'react';
import { QuantPortfolioSummary } from '../../../services/stockService';
import GlassCard from '../../ui/GlassCard';

interface VirtualPortfolioSummaryProps {
  summary: QuantPortfolioSummary | null;
  loading?: boolean;
}

export const VirtualPortfolioSummary: React.FC<VirtualPortfolioSummaryProps> = ({ summary, loading = false }) => {
  if (loading && !summary) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <GlassCard key={i} className="h-24 animate-pulse bg-white/5">
            <div />
          </GlassCard>
        ))}
      </div>
    );
  }

  if (!summary) return null;

  const { totalPnL, winRate, activePositions, closedPositions, winningPositions, totalPositions } = summary;

  const pnlColor = totalPnL > 0 ? 'text-red-400' : totalPnL < 0 ? 'text-green-400' : 'text-white';
  const winRateColor = winRate >= 50 ? 'text-red-400' : 'text-green-400';

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <GlassCard className="p-4 flex flex-col justify-center">
        <div className="text-white/40 text-[10px] uppercase tracking-wider mb-1">Total PnL</div>
        <div className={`text-2xl font-bold ${pnlColor}`}>
          {totalPnL > 0 ? '+' : ''}{totalPnL.toFixed(2)}
        </div>
        <div className="text-[10px] text-white/30 mt-1">Realized Profit/Loss</div>
      </GlassCard>

      <GlassCard className="p-4 flex flex-col justify-center">
        <div className="text-white/40 text-[10px] uppercase tracking-wider mb-1">Win Rate</div>
        <div className={`text-2xl font-bold ${winRateColor}`}>
          {winRate.toFixed(1)}%
        </div>
        <div className="text-[10px] text-white/30 mt-1">
          {winningPositions} wins / {closedPositions} closed
        </div>
      </GlassCard>

      <GlassCard className="p-4 flex flex-col justify-center">
        <div className="text-white/40 text-[10px] uppercase tracking-wider mb-1">Active Positions</div>
        <div className="text-2xl font-bold text-blue-400">
          {activePositions}
        </div>
        <div className="text-[10px] text-white/30 mt-1">Currently Holding</div>
      </GlassCard>

      <GlassCard className="p-4 flex flex-col justify-center">
        <div className="text-white/40 text-[10px] uppercase tracking-wider mb-1">Total Trades</div>
        <div className="text-2xl font-bold text-white">
          {totalPositions}
        </div>
        <div className="text-[10px] text-white/30 mt-1">Cumulative Orders</div>
      </GlassCard>
    </div>
  );
};
